import { RhDatePickerFormik } from "@rhythm-ui/react";
import dayjs from "dayjs";
import { useFormikContext } from "formik";
import React, { useEffect } from "react";

type Props = {
  name?: string;
  label?: string;
  helperText?: string;
};

const EventDateTimeField = ({
  name = "event_time",
  label = "Edit only if the status change happened at a different time.",
}: Props) => {
  const { values, setFieldValue } = useFormikContext<any>();

  const minDate = dayjs().subtract(7, "day").startOf("day").toDate();

  useEffect(() => {
    const value = values?.[name];

    if (Array.isArray(value) && value[0] instanceof Date) {
      setFieldValue(name, value[0].toISOString());
    }
  }, [values?.[name]]);

  return (
    <RhDatePickerFormik
      options={{
        enableTime: true,
        defaultDate: dayjs().toDate(),
        minDate: minDate,
        allowInput: true,
        maxDate: dayjs().toDate(),
      }}
      name={name}
      label={label}
    />
  );
};

export default EventDateTimeField;
